import { render } from "./TranslitPage.vue?vue&type=template&id=213daac0&scoped=true"
import script from "./TranslitPage.vue?vue&type=script&lang=js"
export * from "./TranslitPage.vue?vue&type=script&lang=js"

import "./TranslitPage.vue?vue&type=style&index=0&id=213daac0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\feegor\\PycharmProjects\\menlor\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213daac0"]])

export default __exports__